export * from './communiques/communiques.page';
